export default "__VITE_PUBLIC_ASSET__6f0077b0__"